import {useEffect} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import useDidUpdateEffect from '../../hooks/useDidUpdateEffect';
import initialiseBillingAddressForPaymentType
  from '../../v2/actions/paymentActions/billingAddressActions/initialiseBillingAddressForPaymentType';
import getSessionDataForOptty from '../../v2/actions/paymentActions/optty/getSessionDataForOptty';
import {addPaymentOptions} from '../../v2/actions/paymentActions/payment-actions';
import getOpttySessionData from '../../v2/selectors/PaymentOptionSelectors/Optty/getOpttySessionData';
import {getSettings} from '../../v2/selectors/selectors';
import doMetric from '../../v2/tracking/bigQueryMetricRecorder';
import Track from '../../v2/utils/tracking';

export const OpttyOptionsLoader = (props) => {
  useEffect(() => {
    if (!props.opttySessionData) {
      props.getSessionDataForOptty();
    }
  }, [props.opttySessionData, props.getSessionDataForOptty]);
  
  useDidUpdateEffect(() => {
    if (props.opttySessionData) {
      const {availablePaymentOptions} = props.opttySessionData;
      
      const filteredOptions = availablePaymentOptions.filter(option => !props.opttyBlockedPaymentMethods?.includes(option.name));
      
      const paymentOptions = filteredOptions.map(option => ({
        ...option,
        type: option.providerName,
        isOpttyOption: true,
        requiresBillingAddress: props.opttySubTypesRequiringGenericBillingAddress?.includes(option.providerName),
      }));
  
      props.addPaymentOptions(paymentOptions);

      paymentOptions.forEach((opttyOption) => {
        if (props.opttySubTypesRequiringGenericBillingAddress?.length
          && props.opttySubTypesRequiringGenericBillingAddress.includes(opttyOption.providerName)) {
          props.initialiseBillingAddressForPaymentType(`Optty_${opttyOption.providerName}`);
        }
      });
      
      try {
        doMetric(
          'optty',
          [
            {name: 'paymentOptionsReturned', value: paymentOptions},
          ],
        );
      } catch (error) {
        Track.track(`Unable to track Optty payment options returned. ${error}`);
      }
    }
  }, [
    props.opttySessionData,
  ]);
  
  return null;
};

OpttyOptionsLoader.propTypes = {
  opttySessionData: PropTypes.shape({
    availablePaymentOptions: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        providerName: PropTypes.string.isRequired,
        imageUrl: PropTypes.string.isRequired,
        minAmount: PropTypes.number.isRequired,
        maxAmount: PropTypes.number.isRequired,
      }),
    ),
    widgetSessionToken: PropTypes.string,
  }),
  getSessionDataForOptty: PropTypes.func.isRequired,
  addPaymentOptions: PropTypes.func.isRequired,
  opttyBlockedPaymentMethods: PropTypes.arrayOf(PropTypes.string),
  opttySubTypesRequiringGenericBillingAddress: PropTypes.arrayOf(PropTypes.string),
  initialiseBillingAddressForPaymentType: PropTypes.func,
};

const mapStateToProps = (state) => {
  const settings = getSettings(state);
  return {
    opttySessionData: getOpttySessionData(state),
    opttySubTypesRequiringGenericBillingAddress: settings?.optty_sub_types_requiring_generic_billing_address,
  };
};

const mapDispatchToProps = {
  getSessionDataForOptty,
  addPaymentOptions,
  initialiseBillingAddressForPaymentType,
};

export default connect(mapStateToProps, mapDispatchToProps)(OpttyOptionsLoader);
